import client from './client';
import type { PagedResult } from './anbiyam';

export type ExportJobStatus = 'Queued' | 'Rendering' | 'Zipping' | 'Ready' | 'Failed';
export type ExportGroupingMode = 'per-year' | 'combined';
export type ExportJobType = 'statement' | 'collection-sheet';

export interface ExportJob {
  id:            number;
  requested_by:  string;
  anbiyam_ids:   string; // JSON array, as stored
  years:         string; // JSON array, as stored
  grouping_mode: ExportGroupingMode;
  job_type:      ExportJobType;
  status:        ExportJobStatus;
  file_count:    number | null;
  s3_key:        string | null;
  error_message: string | null;
  created_at:    string;
  completed_at:  string | null;
  downloadUrl?:  string | null;
}

export const createExportJob = async (payload: {
  anbiyamIds: number[];
  years:      number[];
  grouping?:  ExportGroupingMode;
  jobType?:   ExportJobType;
}): Promise<ExportJob> => {
  const { data } = await client.post<{ data: ExportJob }>('/subscriptions/export-jobs', payload);
  return data.data;
};

export const listExportJobs = async (params: {
  page?: number; pageSize?: number;
} = {}): Promise<PagedResult<ExportJob>> => {
  const { data } = await client.get<{ data: PagedResult<ExportJob> }>('/subscriptions/export-jobs', { params });
  return data.data;
};

export const getExportJob = async (id: number): Promise<ExportJob> => {
  const { data } = await client.get<{ data: ExportJob }>(`/subscriptions/export-jobs/${id}`);
  return data.data;
};
